/** Fixed design resolution, mandated by SPEC.md - the canvas never changes size. */
export const VIEW_WIDTH = 1280;
export const VIEW_HEIGHT = 720;

/** The scrollable world inside a level is wider than the viewport - there is somewhere to walk to. */
export const WORLD_WIDTH = 2560;
export const WORLD_HEIGHT = VIEW_HEIGHT;
